import currency from "currency.js";
import type { FindUserPackageBookingByIdPackageBooking } from "@/app/lib/types/codegen";
import { TripPlanCard } from "../bookingFlow/tripDetails/TripPlanCard";
import { AdditionalInformationCard } from "../bookingFlow/tripDetails/AdditionalInformationCard";
import { TermsAndConditionsCard } from "../bookingFlow/tripDetails/TermsAndConditionsCard";
import { PriceDetailsCard } from "../bookingFlow/summary/PriceDetailsCard";
import { VisaPermissionsCard } from "../bookingFlow/tripDetails/VisaPermissionsCard";
import { OverviewCard } from "./OverviewCard";
import { TravellerListCard, TravellerListItem } from "../TravellerListCard";

type Props = {
  reservation: FindUserPackageBookingByIdPackageBooking;
};

export const MyTrip = ({ reservation }: Props) => {
  return (
    <div className="space-y-3">
      <OverviewCard trip={reservation} />
      <TripPlanCard itineraries={reservation.package.itineraries} />
      <TravellerListCard>
        {reservation.travelers.map(
          ({ id, firstName, lastName, passportNumber }) => (
            <TravellerListItem
              key={id}
              name={`${firstName} ${lastName}`}
              additionalData={[
                `${passportNumber.slice(0, 3)}****
                      ${passportNumber.slice(-2)}`,
              ]}
            />
          ),
        )}
      </TravellerListCard>
      <PriceDetailsCard
        totalPrice={reservation.price}
        totalDiscount={
          currency(reservation.price, {
            precision: 3,
          }).subtract(reservation.discountedPrice).value
        }
        totalDiscountedPrice={reservation.discountedPrice}
      />
      <VisaPermissionsCard countries={reservation.package.countries} />
      {reservation.package.additionalInformation ? (
        <AdditionalInformationCard
          content={reservation.package.additionalInformation}
        />
      ) : null}
      {reservation.package.termsAndConditions ? (
        <TermsAndConditionsCard
          content={reservation.package.termsAndConditions}
        />
      ) : null}
    </div>
  );
};
